import { LOCALES } from 'i18n/locales';

export const workpackAlertModalIntl = {
    [LOCALES.ENGLISH]: {
        'workpackAlerts.modal.button.save.text': 'Accept and continue',
        'workpackAlerts.modal.delete.title': 'Delete this PDF',
        'workpackAlerts.modal.delete.body': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
        'workpackAlerts.modal.button.delete.text': 'Delete',
        'workpackAlerts.modal.button.cancel.text': 'Cancel'
    },
    [LOCALES.WELSH]: {
        'workpackAlerts.modal.button.save.text': '[Accept and continue]',
        'workpackAlerts.modal.delete.title': '[Delete this PDF]',
        'workpackAlerts.modal.delete.body': '[Are you sure you want to delete "{title}"? This action cannot be undone.]',
        'workpackAlerts.modal.button.delete.text': '[Delete]',
        'workpackAlerts.modal.button.cancel.text': '[Cancel]'
    }
};
